<template>
  <el-dialog
    title="成绩录入"
    :visible.sync="value"
    :width="oddOrEven && this.bowType != 3 ? '60%' : '40%'"
    :before-close="gradeInDialogClose"
    :close-on-click-modal="false"
  >
    <div class="title">
      <span>弓种：</span>
      <el-select
        placeholder="请选择弓种"
        size="small"
        v-model="bowType"
        @change="changeBowType"
      >
        <el-option
          v-for="item in this.bowTypeList"
          :label="item.title"
          :value="item.value"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-button
        size="small"
        type="primary"
        @click="show18"
        class="ml15"
        v-if="memberPoints >= 300 && bowType != 3"
        >{{ oddOrEven ? "双榜" : "单榜" }}
      </el-button>
    </div>
    <div class="showOne" v-if="!oddOrEven">
      <div class="mi10">
        <div class="title">
          <span>米数：</span>
          <el-select placeholder="请选择米数" size="small" v-model="meterType">
            <el-option
              label="10米"
              value="10"
              v-if="this.bowType != 3"
            ></el-option>
            <el-option label="18米" value="18"></el-option>
          </el-select>
          <el-button
            type="primary"
            class="ml45"
            @click="addRroup10()"
            size="mini"
            >添加
          </el-button>
        </div>
        <div
          class="position"
          v-for="(item, index) in scoreList10"
          :key="index + 1000"
        >
          <i
            v-if="item.title != '第1组'"
            class="el-icon-remove-outline positionA"
            @click="gradeOut10(item)"
          ></i>
          <div class="rowList">
            <span>{{ item.title }}：</span>
            <el-input
              maxlength="3"
              v-model="item.score"
              size="mini"
              placeholder="请输入总环数"
              @input="inputoooo($event, index, '10')"
              :ref="index"
            ></el-input>
            <div class="button">
              <!-- 测试上传两张图片
        <el-upload
        accept=".png,.jpg,.jpeg,.JPG,.JPEG"
        :headers="headers"
        :action="upLoadUrl"
        :show-file-list="false"
        :file-list="listPic"
        :limit="2"
         :on-success="handlePic"
      >
        <span v-if="listPic.length != 2">上传照片</span>
        <span v-if="listPic.length == 2">上传完毕</span>
      </el-upload>
      <div v-if="listPic.length != 0" class="uped">
        <el-popover placement="right" width="400" trigger="click">
          <div v-for="(item, index) in listPic" :key="index">
            <img
              :src="globelurls + item.url"
              alt=""
              style="width: 100px; height: 100px"
            />
            <div @click="removeImg(index)">删除</div>
          </div>

          <el-button class="minibutton" slot="reference" type="primary"
            >查看</el-button
          >
        </el-popover>
      </div> 测试上传两张图片-->
              <el-upload
                accept=".png,.jpg,.jpeg,.JPG,.JPEG"
                :headers="headers"
                :action="upLoadUrl"
                :show-file-list="false"
                :file-list="item.listPic"
                :limit="2"
                :on-success="
                  creatHandleAvatarSuccess10.bind(null, {
                    index: index,
                    data: item,
                  })
                "
              >
                <span v-if="item.listPic.length != 2">上传照片</span>
                <span v-if="item.listPic.length == 2">上传完毕</span>
              </el-upload>
            </div>
            <div v-if="item.listPic.length != 0" class="uped">
              <el-popover placement="right" width="400" trigger="click">
                <div v-for="(items, indexss) in item.listPic" :key="indexss">
                  <img
                    :src=" globelurls + items.url"
                    alt=""
                    style="width: 200px; height: 200px"
                  />
                  <div @click="removeImg10(index, indexss)" class="removeClass">删除</div>
                </div>
                <el-button class="minibutton" slot="reference" type="primary"
                  >查看</el-button
                >
              </el-popover>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="showTwo" v-if="oddOrEven">
      <div class="flex">
        <div class="mi10">
          <div class="title">
            <span> <span>米数：</span><span>10米</span> </span>
            <el-button
              type="primary"
              class="ml45"
              @click="addRroup10()"
              size="mini"
              >添加</el-button
            >
          </div>
          <div
            class="position"
            v-for="(item, index) in scoreList10"
            :key="index + 10"
          >
            <i
              v-if="item.title != '第1组'"
              class="el-icon-remove-outline positionA"
              @click="gradeOut10(item)"
            ></i>
            <div class="rowList">
              <span>{{ item.title }}：</span>
              <el-input
                maxlength="3"
                v-model="item.score"
                size="mini"
                placeholder="请输入总环数"
                @input="inputoooo($event, index, '10')"
                :ref="index"
              ></el-input>
              <div class="buttonTwo">
                <!-- <el-upload
                  accept=".png,.jpg,.jpeg,.JPG,.JPEG"
                  :headers="headers"
                  :action="upLoadUrl"
                  :show-file-list="false"
                  :on-success="
                    creatHandleAvatarSuccess10.bind(null, {
                      index: index,
                      data: item,
                    })
                  "
                >
                  <span v-if="!item.photoPath">上传照片</span>
                  <span v-if="item.photoPath">重新上传</span>
                </el-upload> -->
                <el-upload
                  accept=".png,.jpg,.jpeg,.JPG,.JPEG"
                  :headers="headers"
                  :action="upLoadUrl"
                  :show-file-list="false"
                  :file-list="item.listPic"
                  :limit="2"
                  :on-success="
                    creatHandleAvatarSuccess10.bind(null, {
                      index: index,
                      data: item,
                    })
                  "
                >
                  <span v-if="item.listPic.length != 2">上传照片</span>
                  <span v-if="item.listPic.length == 2">上传完毕</span>
                </el-upload>
              </div>
              <!-- <div v-if="item.photoPath" class="uped">
                <el-popover placement="right" width="400" trigger="click">
                  <img
                    :src="globelurls + item.photoPath"
                    alt=""
                    class="upphoto"
                  />
                  <el-button class="minibutton" slot="reference" type="primary"
                    >查看</el-button
                  >
                </el-popover>
              </div> -->
              <div v-if="item.listPic.length != 0" class="uped">
                <el-popover placement="right" width="400" trigger="click">
                  <div v-for="(items, indexss) in item.listPic" :key="indexss">
                    <img
                      :src="globelurls + items.url"
                      alt=""
                      style="width: 100px; height: 100px"
                    />
                    <div @click="removeImg10(index, indexss)">删除</div>
                  </div>
                  <el-button class="minibutton" slot="reference" type="primary"
                    >查看</el-button
                  >
                </el-popover>
              </div>
            </div>
          </div>
        </div>
        <div class="mi18">
          <div class="title">
            <span>米数：</span><span>18米</span>
            <el-button
              type="primary"
              class="ml45"
              @click="addRroup18()"
              size="mini"
              >添加</el-button
            >
          </div>
          <div
            class="position"
            v-for="(item, index) in scoreList18"
            :key="index + 10000"
          >
            <i
              v-if="item.title != '第1组'"
              class="el-icon-remove-outline positionA"
              @click="gradeOut18(item)"
            ></i>
            <div class="rowList">
              <span>{{ item.title }}：</span>
              <el-input
                maxlength="3"
                v-model="item.score"
                size="mini"
                placeholder="请输入总环数"
                @input="inputoooo($event, index, '18')"
                :ref="index + 1000"
              ></el-input>
              <div class="buttonTwo">
                <!-- <el-upload
                  accept=".png,.jpg,.jpeg,.JPG,.JPEG"
                  :headers="headers"
                  :action="upLoadUrl"
                  :show-file-list="false"
                  :on-success="
                    creatHandleAvatarSuccess18.bind(null, {
                      index: index,
                      data: item,
                    })
                  "
                >
                  <span v-if="!item.photoPath">上传照片</span>
                  <span v-if="item.photoPath">重新上传</span>
                </el-upload> -->
                <el-upload
                  accept=".png,.jpg,.jpeg,.JPG,.JPEG"
                  :headers="headers"
                  :action="upLoadUrl"
                  :show-file-list="false"
                  :file-list="item.listPic"
                  :limit="2"
                  :on-success="
                    creatHandleAvatarSuccess18.bind(null, {
                      index: index,
                      data: item,
                    })
                  "
                >
                  <span v-if="item.listPic.length != 2">上传照片</span>
                  <span v-if="item.listPic.length == 2">上传完毕</span>
                </el-upload>
              </div>
              <!-- <div v-if="item.photoPath" class="uped">
                <el-popover placement="right" width="400" trigger="click">
                  <img
                    :src="globelurls + item.photoPath"
                    alt=""
                    class="upphoto"
                  />
                  <el-button class="minibutton" slot="reference" type="primary"
                    >查看</el-button
                  >
                </el-popover>
              </div> -->
              <div v-if="item.listPic.length != 0" class="uped">
                <el-popover placement="right" width="400" trigger="click">
                  <div v-for="(items, indexss) in item.listPic" :key="indexss">
                    <img
                      :src="globelurls + items.url"
                      alt=""
                      style="width: 100px; height: 100px"
                    />
                    <div @click="removeImg18(index, indexss)">删除</div>
                  </div>
                  <el-button class="minibutton" slot="reference" type="primary"
                    >查看</el-button
                  >
                </el-popover>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="gradeInPayment">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { bowType } from "../../api/OperationManagement";
import {
  gradeInPayment,
  getMemberScoreByOrder,
} from "@/api/OrderManagement.js";
import { posturl, globelurl } from "../../api/axios.js";
export default {
  name: "gradeIn",
  watch: {
    value: {
      handler(newValue, oldValue) {
        if (newValue) {
          //获取成绩录入回显
          getMemberScoreByOrder({
            memberId: this.memberId,
            orderId: this.orderId,
          }).then((res) => {
            if (res.status === 200 && res.data.success) {
              if (res.data.result.length >= 1) {
                // console.log(res, "成绩录入");
                this.bowType = res.data.result[0].bowType;
                this.oddOrEven = res.data.result[0].oddOrEven;
                if (this.bowType == 3) {
                  // console.log("录入复合弓");
                  this.meterType = res.data.result[0].meterType;
                  this.scoreList10 = [];
                  // res.data.result.forEach((item, index) => {
                  //   this.scoreList10.push({
                  //     photoPath: item.photoPath.split(","), //照片
                  //     score: item.score, //成绩
                  //     title: `第${this.scoreList10.length + 1}组`,
                  //     listPic: [].push({
                  //       url: item.photoPath.split(",")[index],
                  //     }),
                  //   });
                  // });
                  res.data.result.forEach((item) => {
                    let listPic = [];
                    if (item.photoPath) {
                      item.photoPath = item.photoPath.split(",");
                      item.photoPath.forEach((itm) => {
                        listPic.push({
                          url: itm,
                        });
                      });
                    } else {
                      item.photoPath = [];
                      item.listPic = [];
                    }
                    this.scoreList10.push({
                      photoPath: item.photoPath, //照片
                      score: String(item.score), //成绩
                      title: `第${this.scoreList10.length + 1}组`,
                      listPic: listPic,
                    });
                  });
                } else {
                  if (res.data.result[0].oddOrEven) {
                    // console.log("录入双榜");
                    this.scoreList10 = [];
                    this.scoreList18 = [];

                    // res.data.result.forEach((item, index) => {
                    //   if (item.meterType == "10") {
                    //     this.scoreList10.push({
                    //       photoPath: item.photoPath.split(","), //照片
                    //       score: item.score, //成绩
                    //       title: `第${this.scoreList10.length + 1}组`,
                    //       listPic: [].push({
                    //         url: item.photoPath.split(",")[index],
                    //       }),
                    //     });
                    //   } else if (item.meterType == "18") {
                    //     this.scoreList18.push({
                    //       photoPath: item.photoPath.split(","), //照片
                    //       score: item.score, //成绩
                    //       title: `第${this.scoreList18.length + 1}组`,
                    //       listPic: [].push({
                    //         url: item.photoPath.split(",")[index],
                    //       }),
                    //     });
                    //   }
                    // });
                    res.data.result.forEach((item) => {
                      let listPic = [];
                      if (item.photoPath) {
                        item.photoPath = item.photoPath.split(",");
                        item.photoPath.forEach((itm) => {
                          listPic.push({
                            url:  itm,
                          });
                        });
                      } else {
                        item.photoPath = [];
                        item.listPic = [];
                      }
                      if (item.meterType == "10") {
                        this.scoreList10.push({
                          photoPath: item.photoPath, //照片
                          score: String(item.score), //成绩
                          title: `第${this.scoreList10.length + 1}组`,
                          listPic: listPic,
                        });
                      } else if (item.meterType == "18") {
                        this.scoreList18.push({
                          photoPath: item.photoPath, //照片
                          score: String(item.score), //成绩
                          title: `第${this.scoreList18.length + 1}组`,
                          listPic: listPic,
                        });
                      }
                    });
                  } else {
                    // console.log("录入单榜,录入复合弓与录入单榜处理一致");
                    this.scoreList10 = [];
                    this.meterType = res.data.result[0].meterType;
                    // res.data.result.forEach((item, index) => {
                    //   this.scoreList10.push({
                    //     photoPath: item.photoPath.split(","), //照片
                    //     score: item.score, //成绩
                    //     title: `第${this.scoreList10.length + 1}组`,
                    //     listPic: [].push({
                    //       url: item.photoPath.split(",")[index],
                    //     }),
                    //   });
                    // });
                    res.data.result.forEach((item) => {
                      let listPic = [];
                      if (item.photoPath) {
                        item.photoPath = item.photoPath.split(",");
                        item.photoPath.forEach((itm) => {
                          listPic.push({
                            url: itm,
                          });
                        });
                      } else {
                        item.photoPath = [];
                        item.listPic = [];
                      }
                      this.scoreList10.push({
                        photoPath: item.photoPath,
                        score: String(item.score), //成绩数字转字符串
                        title: `第${this.scoreList10.length + 1}组`,
                        listPic: listPic,
                      });
                    });
                  }
                }
              } else {
                console.log("没有进行成绩录入");
              }
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      },
    },
  },
  props: {
    value: {
      type: Boolean,
    },
    memberId: {
      type: String,
    },
    orderId: {
      type: String,
    },
    memberPoints: {
      type: [Number, String],
    },
  },
  data() {
    return {
      listPic: [],
      headers: { "X-Access-Token": sessionStorage.token },
      upLoadUrl: posturl,
      globelurls: globelurl,
      bowTypeList: [], //弓种下拉
      bowType: "", //弓种
      meterType: "", //,米数
      oddOrEven: false, //false是展示1个榜 true是展示2个榜
      scoreList10: [
        {
          photoPath: [], //照片
          score: "", //成绩
          title: "第1组",
          listPic: [],
        },
      ],
      scoreList18: [
        {
          photoPath: [], //照片
          score: "", //成绩
          title: "第1组",
          listPic: [],
        },
      ],
    };
  },
  mounted() {
    this.getbowType(); // 弓种下拉字典
  },
  methods: {
    getbowType() {
      bowType().then((res) => {
        if (res.data.success) {
          this.bowTypeList = res.data.result;
        }
      });
    },
    // 切换弓种下拉
    changeBowType() {
      if (this.bowType == 3) {
        this.oddOrEven = false;
        this.meterType = "18";
      }
    },
    // 单双榜切换
    show18() {
      this.oddOrEven = !this.oddOrEven;
    },
    // 10米成绩数组添加
    addRroup10() {
      this.scoreList10.push({
        photoPath: [], //照片
        score: "", //成绩
        title: `第${this.scoreList10.length + 1}组`,
        listPic: [],
      });
    },
    // 10米成绩删除
    gradeOut10(item) {
      this.scoreList10 = this.scoreList10.filter((itm) => {
        return item.title != itm.title;
      });
      this.scoreList10.forEach((itm, index) => {
        itm.title = `第${index + 1}组`;
      });
    },
    // 18米成绩添加
    addRroup18() {
      this.scoreList18.push({
        photoPath: [], //照片
        score: "", //成绩
        title: `第${this.scoreList18.length + 1}组`,
        listPic: [],
      });
    },
    // 18米成绩删除
    gradeOut18(item) {
      var item = this.scoreList18.indexOf(item);
      if (item !== -1) {
        this.scoreList18.splice(item, 1);
      }
      this.scoreList18.forEach((itm, index) => {
        itm.title = `第${index + 1}组`;
      });
    },
    // --------------------------------------------------------------
    // 照片上传单榜
    creatHandleAvatarSuccess10(obj, res, file) {
      if (res.success) {
        this.$message({
          message: "上传成功",
          type: "success",
        });
        const index = obj.index;
        // this.scoreList10[index].photoPath = res.result.pathList[0];
        this.scoreList10[index].photoPath.push(res.result.pathList[0]);
        this.scoreList10[index].listPic.push({ url: res.result.pathList[0] });
      } else {
        this.$message.error(res.message);
      }
    },
    // 照片上传双榜
    creatHandleAvatarSuccess18(obj, res, file) {
      if (res.success) {
        this.$message({
          message: "上传成功",
          type: "success",
        });
        const index = obj.index;
        // this.scoreList18[index].photoPath = res.result.pathList[0];
        this.scoreList18[index].photoPath.push(res.result.pathList[0]);
        this.scoreList18[index].listPic.push({ url: res.result.pathList[0] });
      } else {
        this.$message.error(res.message);
      }
    },
    removeImg10(i, inx) {
      this.scoreList10[i].photoPath.splice(inx, 1);
      this.scoreList10[i].listPic.splice(inx, 1);
    },
    removeImg18(i, inx) {
      this.scoreList18[i].photoPath.splice(inx, 1);
      this.scoreList18[i].listPic.splice(inx, 1);
    },
    // handlePic(res, file) {
    //   if (res.success) {
    // this.listPic.push({
    //   url: res.result.pathList[0],
    // });
    // }
    // },
    // removeImg(inx) {
    // this.listPic.splice(inx, 1);
    // },
    // 成绩录入
    gradeInPayment() {
      if (this.bowType == "") {
        this.$message({
          message: "请选择弓种",
          type: "warning",
        });
      } else if (!this.oddOrEven && this.meterType == "") {
        // 只有单榜选择米数
        this.$message({
          message: "请选择米数",
          type: "warning",
        });
      } else {
        let flag = true;
        let scoreList = [];
        if (this.bowType == 3) {
          this.scoreList10.forEach((item) => {
            item.meterType = "18";
          });
          scoreList = this.scoreList10;
        } else {
          if (this.oddOrEven) {
            this.scoreList10.forEach((item) => {
              item.meterType = "10";
            });
            this.scoreList18.forEach((item) => {
              item.meterType = "18";
            });
            scoreList = this.scoreList10.concat(this.scoreList18);
          } else {
            // 单榜 可能10米 可能18米
            this.scoreList10.forEach((item) => {
              item.meterType = this.meterType;
            });
            scoreList = this.scoreList10;
          }
        }
        for (let i = 0; i < scoreList.length; i++) {
          if (scoreList[i].score == "") {
            flag = false;
            this.$message({
              message: "请填写成绩",
              type: "warning",
            });
            break;
          } else if (scoreList[i].score > 120) {
            flag = false;
            this.$message({
              message: "最高成绩为120环",
              type: "warning",
            });
            break;
          }
        }
        if (flag) {
          scoreList.forEach((it, index) => {
            it.bowType = this.bowType;
            it.orderId = this.orderId;
            it.memberId = this.memberId;
            it.oddOrEven = this.oddOrEven;
            it.groupIndex = index;
            it.photoPath = it.photoPath.join();
          });
          console.log(scoreList);
          gradeInPayment({ scoreList }).then((res) => {
            if (res.status === 200 && res.data.success) {
              this.$message({
                message:
                  "操作成功" +
                  "," +
                  "操作人" +
                  ":" +
                  sessionStorage.realName +
                  "," +
                  "本次操作已被记录存档",
                type: "success",
              });
              this.gradeInDialogClose();
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      }
    },
    // 关闭弹窗
    gradeInDialogClose() {
      this.$emit("inputGradeInClose", false);
      this.bowType = "";
      this.meterType = "";
      this.oddOrEven = false;
      this.scoreList10 = [
        {
          photoPath: [], //照片
          score: "", //成绩
          title: "第1组",
          listPic: [],
        },
      ];
      this.scoreList18 = [
        {
          photoPath: [], //照片
          score: "", //成绩
          title: "第1组",
          listPic: [],
        },
      ];
    },
    // 自动跳
    inputoooo(val, i, whichArr) {
      // console.log(val, "输入框的值");
      // console.log(i, "数组的下标");
      if (whichArr == 10) {
        console.log(i);
        if (val > 120 || val < 0) {
          this.$message({
            message: "请正确填写成绩(成绩为1-120环) ",
            type: "warning",
          });
          this.scoreList10[i].score = "";
          return;
        }
        if (val > 12 && val <= 120 && i * 1 + 1 < this.scoreList10.length) {
          let d = i + 1;
          this.$nextTick(() => {
            this.$refs[d][0].focus();
          });
        }
      } else if (whichArr == 18) {
        console.log(i + 1000);
        if (val > 120 || val < 0) {
          this.$message({
            message: "请正确填写成绩(成绩为1-120环) ",
            type: "warning",
          });
          this.scoreList18[i].score = "";
          return;
        }
        if (val > 12 && val <= 120 && i * 1 + 1 < this.scoreList18.length) {
          let d = i + 1 + 1000;
          this.$nextTick(() => {
            this.$refs[d][0].focus();
          });
        }
      }
    },
  },
};
</script>
<style scoped>
.title {
  margin-left: 40px;
  margin-bottom: 20px;
}
.ml15 {
  margin-left: 15px;
}
.showOne {
  /* background: yellowgreen; */
}
.ml45 {
  margin-left: 45px;
}
.position {
  position: relative;
  margin-bottom: 10px;
  /* background: yellow; */
}
.positionA {
  position: absolute;
  top: 3px;
  left: 15px;
  color: red;
}
.rowList {
  position: relative;
  margin-left: 40px;
  display: flex;
}
.rowList .el-input {
  width: 40%;
}
.rowList .button {
  position: absolute;
  /* top: -18px; */
  left: 50%;
}
.upphoto {
  width: 350px;
  height: 350px;
}
.spanup {
  /* background: turquoise; */
}
.uped {
  /* background: yellow; */
}
/* 已上传按钮 */
.minibutton {
  background: rgb(64, 158, 255);
  width: 80px;
  height: 18px;
  line-height: 0px;
  text-align: center;
  margin-left: 120%;
}
.flex {
  display: flex;
}
.flex > div {
  width: 48%;
}
.buttonTwo {
  position: absolute;
  top: -18px;
  left: 53%;
}
.removeClass{
  width: 50px;
  padding:5px 8px;
  border: 1px solid red;
  color: red;
  border-radius: 5px;
  margin:5px 0;
}
</style>

